module.exports = __webpack_public_path__ + "img/frozen.00e8273d.svg";